module.exports = __webpack_public_path__ + "static/media/LogoSabor.28f49c7c.png";